import { z } from "zod";

export const DraftKeySchema = z
  .string()
  .regex(
    /^(metadata|settings|chapters|casting|guidance|chapter-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/,
  );
export const DraftSchema = z.strictObject({
  key: DraftKeySchema,
  revision: z.int().positive(),
  baseToken: z.string(),
  content: z.record(z.string(), z.unknown()),
  updatedAt: z.string(),
});
export type WorkspaceDraft = z.infer<typeof DraftSchema>;
export const DraftReadSchema = z.strictObject({
  currentToken: z.string(),
  draft: DraftSchema.nullable(),
});
export type DraftRead = z.infer<typeof DraftReadSchema>;
export const DraftWriteSchema = z.strictObject({
  revision: z.int().nonnegative(),
  baseToken: z.string(),
  content: z.record(z.string(), z.unknown()),
});
export const DraftRevisionSchema = z.strictObject({ revision: z.int().positive() });
export const DraftSummarySchema = DraftSchema.omit({ content: true, baseToken: true });
